var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 52 52",
    enableBackground: "new 0 0 52 52",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,4h-9C4.7,4,4,4.7,4,5.5v17C4,23.3,4.7,24,5.5,24h9c0.8,0,1.5-0.7,1.5-1.5v-17C16,4.7,15.3,4,14.5,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5,4h-9C20.7,4,20,4.7,20,5.5v17c0,0.8,0.7,1.5,1.5,1.5h9c0.8,0,1.5-0.7,1.5-1.5v-17 C32,4.7,31.3,4,30.5,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5,4h-9C36.7,4,36,4.7,36,5.5v17c0,0.8,0.7,1.5,1.5,1.5h9c0.8,0,1.5-0.7,1.5-1.5v-17 C48,4.7,47.3,4,46.5,4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,28h-9C4.7,28,4,28.7,4,29.5v17C4,47.3,4.7,48,5.5,48h9c0.8,0,1.5-0.7,1.5-1.5v-17 C16,28.7,15.3,28,14.5,28z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5,28h-9c-0.8,0-1.5,0.7-1.5,1.5v17c0,0.8,0.7,1.5,1.5,1.5h9c0.8,0,1.5-0.7,1.5-1.5v-17 C32,28.7,31.3,28,30.5,28z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5,28h-9c-0.8,0-1.5,0.7-1.5,1.5v17c0,0.8,0.7,1.5,1.5,1.5h9c0.8,0,1.5-0.7,1.5-1.5v-17 C48,28.7,47.3,28,46.5,28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrd);
export default __webpack_public_path__ + "static/media/crd.2928de88f3cc124ba67a14285d57bde6.svg";
export { ForwardRef as ReactComponent };